import styled from "styled-components"

import ErrorText from "@irati/ui/src/ErrorText"

interface RadioGroupLabelProps {
  error?: boolean
}
export const RadioGroupLabel = styled.label<RadioGroupLabelProps>`
  color: ${({theme, error}) => (error ? theme.colors.tertiary.r_400 : theme.colors.utility.ink)};
  margin-bottom: 10px;
`

export const RadioGroupError = styled(ErrorText)`
  margin-bottom: 10px;
`

export const RadioInput = styled.input`
  position: absolute;
  z-index: -1;
`

interface RadioOptionLabelProps {
  inline?: boolean
}
export const RadioOptionLabel = styled.label<RadioOptionLabelProps>`
  display: inline-block;
  max-width: none;
  font-weight: normal;
  padding: 0;
  margin: 0 0 1px 0;
  ${({inline}) => inline && "width: auto;"}
  ${({inline}) => !inline && "display: flex;"}
`
